import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { useHistory } from 'react-router-dom';
import BreadCrumb from './BreadCrumb';
import { useSelector } from 'react-redux';
import { isWebviewMode } from 'Utils/webviewMode';
import ToogleSeoText from '../../components/ToogleSeoText';

const StreamGuide = ({ data, isSideNavOpen, setIsSideNavOpen  }) => {
  const history = useHistory();
  const userAgent = useSelector(state => state.userAgent);
  const isMobile = userAgent?.device?.type === 'mobile';
  const isWebview = isWebviewMode(history?.location?.search);

  const streamGuideCategory = data.leagues.find(category =>
    category.name === 'Canlı Yayin Rehberi' || category.name === 'Canlı Yayın Rehberi'
  );

  const streamGuides = streamGuideCategory?.streamGuides || [];
  const [activeTab, setActiveTab] = useState(0);

  const renderMobileTabs = () => (
    <div className="league-card__menu sliding-menu-default-theme">
      <div className="sliding-menu">
        <ul>
          { streamGuides.map((tab, idx) => (
            <li
              key={ tab.title }
              className={ activeTab === idx ? 'active' : '' }
              onClick={ () => setActiveTab(idx) }
            >
              { tab.title }
            </li>
          )) }
        </ul>
      </div>
    </div>
  );

  const renderStreamGuideContent = () => {
    if (isMobile && streamGuides.length > 0) {
      const guide = streamGuides[activeTab];
      return (
        <div className="stream-guide-box">
          <div className="stream-guide-box__header">
            { guide.icon && <img src={ guide.icon } alt={ guide.title } style={ { width: 18, height: 18, marginRight: 4 } } /> }
            <span>{ guide.title }</span>
          </div>
          <div className="stream-guide-box__body">
            <div className="stream-guide-leagues-grid">
              { guide.groups && guide.groups.length > 0 && guide.groups.map((group, i) => (
                <div className="stream-guide-league" key={ i }>
                  <span className="stream-guide-league__status">
                    { group.icon ? (
                      <img src={ group.icon } alt={ group.name } style={ { width: 18, height: 18, marginRight: 4, borderRadius: 9 } } />
                    ) : (
                      <span className={ group.isLive ? 'dot dot--green' : 'dot dot--red' } />
                    ) }
                  </span>
                  <span className="stream-guide-league__name">{ group.name }</span>
                </div>
              )) }
            </div>
          </div>
        </div>
      );
    }
    return streamGuides.map((guide, idx) => (
      <div className="stream-guide-box" key={ idx }>
        <div className="stream-guide-box__header">
          <img
            src={ guide.icon }
            alt={ guide.name }
            style={ { width: 18, height: 18, marginRight: 4 } }
          />
          <span>{ guide.title }</span>
        </div>
        <div className="stream-guide-box__body">
          <div className="stream-guide-leagues-grid">
            { guide.groups && guide.groups.length > 0 && (
              guide.groups.map((group, i) => (
                <div className="stream-guide-league" key={ i }>
                  <span className="stream-guide-league__status">
                    { group.icon ? (
                      <img
                        src={ group.icon }
                        alt={ group.name }
                        style={ { width: 18, height: 18, marginRight: 4, borderRadius: 9 } }
                      />
                    ) : (
                      <span className={ group.isLive ? 'dot dot--green' : 'dot dot--red' } />
                    ) }
                  </span>
                  <span className="stream-guide-league__name">{ group.name }</span>
                </div>
              ))
            ) }
          </div>
        </div>
      </div>
    ));
  };

  const renderBanners = () => {
    if (!data?.banners?.streamGuide?.length) return null;
    
    const filteredBanners = data.banners.streamGuide.filter(b => b.image);
    if (!filteredBanners.length) return null;
    
    return (
      <div className="league-content__banner-container">
        { filteredBanners.map((banner, idx) =>
          banner.deeplink ? (
            <a
              key={ idx }
              href={ banner.deeplink }
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ banner.image } alt="Canlı Yayın Rehberi" />
            </a>
          ) : (
            <img key={ idx } src={ banner.image } alt="Canlı Yayın Rehberi" />
          )
        ) }
      </div>
    );
  };

  return (
    <div className="league-content">
      <div className={ `league-content__header-container ${isWebview ? 'webview' : 'desktopview'}` }>
        { !isWebview
          && <span
            className="league-content__back"
            onClick={ () => {
              const search = history?.location?.search || '';
              history.push(`/lig-merkezi${ search }`);
            } }
          >
            <Icon iconName="svgBackIcon"/>
          </span>
        }

        <Icon iconName="svgGuideIcon" />
        <span className="league-content__main-title">Canlı Yayın Rehberi</span>
        { isMobile && (
          <div style={ { marginLeft: 'auto' } }>
            { isSideNavOpen
              ? <Icon onClick={ () => setIsSideNavOpen(!isSideNavOpen) } iconName="svgHamburgerClose" />
              : <Icon onClick={ () => setIsSideNavOpen(!isSideNavOpen) } iconName="svgHamburgerMenu" />
            }
          </div>
        ) }
      </div>
      { isMobile && streamGuides.length > 0 && renderMobileTabs() }

      { renderBanners() }

      { isMobile && !isWebview && <BreadCrumb data={ data } activeTab={ streamGuides[activeTab]?.title }/> }

      <div className="stream-guide-list">
        { renderStreamGuideContent() }
      </div>

      <div className="match-card__statistics-info">
        <Icon iconName="svgInfoGrey" />
        <div>
          İstatistik sağlayıcı firma tarafından sunulan verilerde oluşabilecek kusurlardan{ ' ' }
          <span className="match-card__statistics-info-highlight">
            Bilyoner sorumlu değildir.
          </span>
        </div>
      </div>
      <ToogleSeoText
        text={ streamGuideCategory?.meta?.description }
        title={ streamGuideCategory?.meta?.title }
        extraClass="events-container__seo__height-fix"
      />
    </div>
  );
};

StreamGuide.propTypes = {
  data: PropTypes.object.isRequired,
  isSideNavOpen: PropTypes.bool,
  setIsSideNavOpen: PropTypes.func
};

export default StreamGuide;
